import NextHead from 'next/head'
import useTranslation from 'next-translate/useTranslation'

import isProduction from '../../app/utils/isAppProduction'
import getImageUrl from '../../app/utils/getImageUrl'

type HeadProps = {
  title?: string
  description?: string
  imageId?: string | null
  noIndex?: boolean
  hideBrandName?: boolean
}

function Head({
  title,
  description,
  imageId,
  noIndex,
  hideBrandName,
}: HeadProps) {
  const { t } = useTranslation('generated')

  function getTitle() {
    if (hideBrandName) {
      return title
    }

    if (title) {
      return `${title} - ${t('brandName')}`
    }

    return t('brandName')
  }

  const titleWithBrand = getTitle()

  return (
    <NextHead>
      <title>{titleWithBrand}</title>
      <meta
        name="description"
        content={description || t('brandDescription')}
        data-testid="meta-description"
      />
      {/* Open Graph */}
      <meta property="og:title" content={titleWithBrand} />
      <meta
        property="og:description"
        content={description || t('brandDescription')}
      />
      {imageId && <meta property="og:image" content={getImageUrl(imageId)} />}
      {(!isProduction() || noIndex) && (
        <meta name="robots" content="noindex,nofollow" />
      )}
    </NextHead>
  )
}

export default Head
